import { render, staticRenderFns } from "./AgentMemberRegistrationComponent.vue?vue&type=template&id=3ae0f759&"
import script from "./AgentMemberRegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./AgentMemberRegistrationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports